module.exports = __webpack_public_path__ + "imgs/right-arrow.db16750fc860e48ec5cadabd2133b3d5.svg";